import { Text, useDisclosure, useMediaQuery } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';

import { HeaderGlobal } from '../components/navigation/HeaderGlobal';
import { HeaderGlobalMobile } from '../components/navigation/HeaderGlobalMobile';
import { LGPDHeader } from '../components/navigation/LgpdHeader';
import { PlatformHeader } from '../components/navigation/PlatformHeader';
import { AccessModal } from '../components/widgets/AccessModal';
import { Loading } from '../components/widgets/Loading';
import { useAuthContext } from '../contexts/AuthContext';
import { CampanhaContextProvider } from '../contexts/CampanhaContext';
import { FilterContextProvider } from '../contexts/FilterContext';
import { useHeaderContext } from '../contexts/HeaderContext';
import { RatingContextProvider } from '../contexts/RatingContext';
import { VisualizationContextProvider } from '../contexts/VisualizationContext';
import { AdviceHome } from '../pages/assessoria/AdviceHome';
import { ConsentimentoHome } from '../pages/consentimento/ConsentimentoHome';
import { QuizLGPD } from '../pages/consentimento/QuizLGPD';
import { Term } from '../pages/consentimento/Term';
import { BrokerHome } from '../pages/corretor/BrokerHome';
import { NotificationPopover } from '../pages/corretor/leads/gestao/components/NotificationPopover';
import { ConfiguracoesLeads } from '../pages/corretor/leads/gestao/ConfiguracoesLeads';
import { EquipesLeads } from '../pages/corretor/leads/gestao/EquipesLeads';
import GestaoLeads from '../pages/corretor/leads/gestao/GestaoLeads';
import { InserirLead } from '../pages/corretor/leads/gestao/InserirLead';
import { AlterarEquipe } from '../pages/corretor/leads/gestao/partials/AlterarEquipe';
import { CadastroEquipe } from '../pages/corretor/leads/gestao/partials/CadastroEquipe';
import CadastroVendedor from '../pages/corretor/leads/gestao/partials/CadastroVendedor';
import { ConfiguradorNotificacoes } from '../pages/corretor/leads/gestao/partials/ConfiguradorNotificacoes';
import DetalhesVendedor from '../pages/corretor/leads/gestao/partials/DetalhesVendedor';
import KanbanVendedor from '../pages/corretor/leads/gestao/partials/KanbanVendedor';
import { KanbanVendedorMobile } from '../pages/corretor/leads/gestao/partials/KanbanVendedorMobile';
import LeadsMobile from '../pages/corretor/leads/gestao/partials/LeadsMobile';
import { ListaLeads } from '../pages/corretor/leads/gestao/partials/ListaLeads';
import { Notificacoes } from '../pages/corretor/leads/gestao/partials/Notificacoes';
import PerfisLeads from '../pages/corretor/leads/gestao/PerfisLeads';
import HomeLeads from '../pages/corretor/leads/HomeLeads';
import { KanbanLeads } from '../pages/corretor/leads/kanban/KanbanLeads';
import { EvaluationWidget } from '../pages/corretor/leads/kanban/partials/EvaluationWidget';
import LeadDetails from '../pages/corretor/leads/kanban/partials/LeadDetails';
import { CarteiraPrevidencia } from '../pages/corretor/previdencia-individual/CarteiraPrevidencia';
import { CarteiraRecomendada } from '../pages/corretor/previdencia-individual/CarteiraRecomendada';
import { ConsultaPortabilidades } from '../pages/corretor/previdencia-individual/ConsultaPortabilidades';
import { ConsultaResgates } from '../pages/corretor/previdencia-individual/ConsultaResgates';
import { AnaliticoProposta } from '../pages/corretor/previdencia-individual/movimentacao-fundos/pages/AnaliticoProposta';
import { BaseClientes } from '../pages/corretor/previdencia-individual/movimentacao-fundos/pages/BaseClientes';
import { Conclusao } from '../pages/corretor/previdencia-individual/movimentacao-fundos/pages/Conclusao';
import { TransferindoPercentuais } from '../pages/corretor/previdencia-individual/movimentacao-fundos/pages/TransferindoPercentuais';
import { SosPrev } from '../pages/corretor/previdencia-individual/SosPrev';
import { SegmentacaoHeader } from '../pages/corretor/segmentacao/layout/SegmentacaoHeader';
import { SegmentacaoHeaderMobile } from '../pages/corretor/segmentacao/layout/SegmentacaoHeaderMobile';
import { CarteiraViagem } from '../pages/corretor/viagem/CarteiraViagem';
import { CarteiraVida } from '../pages/corretor/vida-individual/CarteiraVida';
import { ContrataFacil } from '../pages/corretor/vida-individual/ContrataFacil';
import { ContrataFacilClientes } from '../pages/corretor/vida-individual/ContrataFacilClientes';
import { PainelVendasWhiteLabel } from '../pages/corretor/white-label/PainelVendasWhiteLabel';
import { PainelWhiteLabel } from '../pages/corretor/white-label/PainelWhiteLabel';
import { StepFive } from '../pages/corretor/white-label/steps/StepFive';
import { StepFour } from '../pages/corretor/white-label/steps/StepFour';
import { StepOne } from '../pages/corretor/white-label/steps/StepOne';
import { StepThree } from '../pages/corretor/white-label/steps/StepThree';
import { StepTwo } from '../pages/corretor/white-label/steps/StepTwo';
import { EmailConfirmation } from '../pages/EmailConfirmation';
import { Login } from '../pages/Login';
import { getDadosLogin } from '../utils/dados-login.util';
import { isJson } from '../utils/isJson.util';
import { tokenPortalFromUrl } from '../utils/portal-token.util';

export const AppRoutes = () => {
  const [isMobile] = useMediaQuery('(max-width: 768px)');

  const { isOpen, onOpen, onClose } = useDisclosure();

  const [isLoading, setIsLoading] = useState(true);

  const [codigoProd, setCodigoProd] = useState(true);

  const location = useLocation();

  const { redirectUser, checkUser } = useAuthContext();
  const { elementSize } = useHeaderContext();

  const navigate = useNavigate();

  const header: JSX.Element = (() => {
    const pathname = location.pathname;
    const isPathName =
      pathname.startsWith('/corretor') ||
      pathname.startsWith('/assessoria') ||
      pathname.startsWith('/corretor');

    let hideWLEl = true;

    if (pathname.startsWith('/corretor/pra360') && isMobile)
      return <SegmentacaoHeaderMobile />;

    if (pathname.startsWith('/corretor/pra360')) return <SegmentacaoHeader />;

    if (pathname.startsWith('/corretor/white-label')) hideWLEl = false;

    if (isPathName && isMobile) return <HeaderGlobalMobile />;

    if (isPathName && !isMobile) return <HeaderGlobal hideWLEl={hideWLEl} />;

    if (pathname.startsWith('/login')) return <div></div>;

    if (pathname.startsWith('/ativacao')) return <div></div>;

    if (pathname.includes('confirmacao-email')) return <div></div>;

    if (
      pathname.startsWith('/consentimento') ||
      pathname.split('/').find((el) => el === 'c')
    )
      return <LGPDHeader />;

    return <PlatformHeader />;
  })();

  useEffect(() => {
    const user = localStorage.getItem('pdn:user');

    if (isJson(user)) {
      const pathname = location.pathname;

      const parsedUser = JSON.parse(user);

      if (parsedUser?.user) {
        if (
          pathname.includes('/corretor') &&
          !parsedUser.user.isManager &&
          !parsedUser.user.sellerWithElevateAccess &&
          pathname !== '/corretor/leads/kanban' &&
          pathname !== '/login' &&
          !pathname.includes('/notificacoes') &&
          !pathname.includes('/confirmacao-email')
        ) {
          navigate('/corretor/leads/kanban');
        }

        if (
          pathname.includes('/corretor') &&
          !parsedUser.user.isManager &&
          parsedUser.user.sellerWithElevateAccess &&
          parsedUser.user?.seller?.redirects_to?.path &&
          pathname !== '/login' &&
          !pathname.includes('/notificacoes') &&
          !pathname.includes('/confirmacao-email')
        ) {
          console.log('resultado aqui', parsedUser.user);
          navigate(parsedUser.user.seller.redirects_to.path);
        }
      }
    }
  }, []);

  useEffect(() => {
    const pathname = location.pathname;
    const token = tokenPortalFromUrl;

    const getUserData = async () => {
      try {
        const dadosLogin = await getDadosLogin({ newLogin: Boolean(token) });

        let code;

        if (dadosLogin.producerCode === '3013634') {
          code = false;
        } else {
          code = true;
        }

        setCodigoProd(code);
      } catch (error: any) {
        if (
          error?.response?.status === 401 &&
          !location.pathname.includes('/confirmacao-email')
        )
          onOpen();
      }
    };

    if (
      pathname.startsWith('/consentimento') ||
      pathname.split('/').find((el) => el === 'c')
    ) {
      setIsLoading(false);
      return;
    }

    if (location.pathname.includes('/confirmacao-email')) {
      setIsLoading(false);
      return;
    }

    if (token) {
      if (
        token === 'undefined' &&
        !location.pathname.includes('/confirmacao-email')
      ) {
        setIsLoading(false);

        onOpen();

        return;
      } else if (location.pathname.includes('/pra360')) {
        redirectUser(onOpen, '/corretor/pra360');
      } else {
        setIsLoading(false);

        redirectUser(onOpen);

        return;
      }
    }

    if (
      window.location.pathname != '/login' &&
      !location.pathname.includes('/confirmacao-email') &&
      !pathname.startsWith('/consentimento') &&
      !pathname.split('/').find((el) => el === 'c')
    ) {
      checkUser();

      getUserData();
    }

    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (location.pathname.startsWith('/corretor/leads')) {
      const user = localStorage.getItem('pdn:user');

      if (isJson(user)) {
        const parsedUser = JSON.parse(user);
        if (parsedUser.user.isManager === true) {
          EvaluationWidget(null, 'UJrynAwC');
        } else {
          EvaluationWidget(null, 'UJryqLzp');
        }
      }
    }
  });

  return (
    <>
      {isLoading ? (
        <Loading>
          <Text>Carregando...</Text>
        </Loading>
      ) : (
        <>
          <VisualizationContextProvider>
            <NotificationPopover
              rightSpace={isMobile ? '4rem' : `${elementSize}px`}
              topSpace={isMobile ? '1rem' : '2.25rem'}
            >
              {header}
            </NotificationPopover>
            <RatingContextProvider>
              <FilterContextProvider>
                <CampanhaContextProvider>
                  <Routes>
                    <Route path="assessoria">
                      <Route index element={<AdviceHome />} />
                    </Route>

                    <Route path="login">
                      <Route index element={<Login />} />
                    </Route>

                    <Route path="corretor">
                      <Route index element={<BrokerHome />} />

                      <Route path="notificacoes" element={<Notificacoes />} />

                      <Route
                        path="notificacoes/configuracoes"
                        element={<ConfiguradorNotificacoes />}
                      />

                      <Route
                        path="viagem/carteira-viagem"
                        element={<CarteiraViagem />}
                      />

                      <Route
                        path="vida-individual/painel-vendas-contrata-facil"
                        element={<ContrataFacil />}
                      />
                      <Route
                        path="vida-individual/painel-vendas-contrata-facil/base-clientes/:status"
                        element={<ContrataFacilClientes />}
                      />
                      <Route
                        path="vida-individual/carteira-vida"
                        element={<CarteiraVida />}
                      />
                      <Route
                        path="previdencia-individual/carteira-previdencia"
                        element={<CarteiraPrevidencia withPagination />}
                      />
                      <Route
                        path="previdencia-individual/consulta-resgates"
                        element={<ConsultaResgates />}
                      />
                      <Route
                        path="previdencia-individual/consulta-portabilidades"
                        element={<ConsultaPortabilidades />}
                      />
                      <Route
                        path="previdencia-individual/sos-prev"
                        element={<SosPrev withPagination />}
                      />
                      <Route
                        path="previdencia-individual/carteira-recomendada"
                        element={<CarteiraRecomendada />}
                      />
                      <Route
                        path="previdencia-individual/movimentacao-fundos/base-clientes"
                        element={<BaseClientes />}
                      />
                      <Route
                        path="previdencia-individual/movimentacao-fundos/analitico-proposta"
                        element={<AnaliticoProposta />}
                      />
                      <Route
                        path="previdencia-individual/movimentacao-fundos/transferindo-percentuais"
                        element={<TransferindoPercentuais />}
                      />
                      <Route
                        path="previdencia-individual/movimentacao-fundos/conclusao"
                        element={<Conclusao />}
                      />

                      <Route path="leads">
                        <Route index element={<HomeLeads />} />
                        <Route path="perfis" element={<PerfisLeads />} />
                        <Route
                          path="configuracoes"
                          element={<ConfiguracoesLeads />}
                        />
                        <Route path="equipes" element={<EquipesLeads />} />
                        <Route
                          path="inserir-lead/:idLeadOrigem"
                          element={<InserirLead />}
                        />
                        <Route path="kanban" element={<KanbanLeads />} />
                        <Route path="gestao" element={<GestaoLeads />} />
                        <Route path="vendedor" element={<DetalhesVendedor />} />
                        <Route path="mobile/leads" element={<LeadsMobile />} />
                        <Route
                          path="mobile/vendedor/painel"
                          element={<KanbanVendedorMobile />}
                        />
                        <Route
                          path="perfis/cadastro"
                          element={<CadastroVendedor />}
                        />
                        <Route path="listagem" element={<ListaLeads />} />
                        <Route path=":idLead" element={<LeadDetails />} />
                        <Route
                          path="equipes/cadastro-equipe"
                          element={<CadastroEquipe />}
                        />
                        <Route
                          path="equipes/alterar-equipe"
                          element={<AlterarEquipe />}
                        />
                        <Route
                          path="vendedor/painel"
                          element={<KanbanVendedor />}
                        />
                      </Route>
                      <Route path="white-label">
                        <Route path="painel" element={<PainelWhiteLabel />} />
                        <Route
                          path="step-one/:idWebsite"
                          element={<StepOne />}
                        />
                        <Route
                          path="step-two/:idWebsite"
                          element={<StepTwo />}
                        />
                        <Route
                          path="step-three/:idWebsite"
                          element={<StepThree />}
                        />
                        <Route
                          path="step-four/:idWebsite"
                          element={<StepFour />}
                        />
                        <Route
                          path="step-five/:idWebsite"
                          element={<StepFive />}
                        />
                        <Route
                          path="painel-vendas/:idWebsite"
                          element={<PainelVendasWhiteLabel />}
                        />
                      </Route>
                    </Route>

                    <Route path="consentimento">
                      <Route index element={<ConsentimentoHome />} />
                      <Route path="accept-term" element={<Term />} />
                      <Route path="quiz" element={<QuizLGPD />} />
                    </Route>

                    <Route path="c/:token">
                      <Route index element={<ConsentimentoHome />} />
                    </Route>

                    <Route
                      path="confirmacao-email"
                      element={<EmailConfirmation />}
                    />
                  </Routes>
                </CampanhaContextProvider>
              </FilterContextProvider>
            </RatingContextProvider>

            <AccessModal isOpen={isOpen} onClose={onClose} />
          </VisualizationContextProvider>
        </>
      )}
    </>
  );
};
